import {
    chainWalk, convertMacToCoreDeviceName,
    convertTableJsonToEdgeGatewayAsset,
    getAPIGatewayPostRequest, getAssetLabelFromMac,
    getNodeId, getSDSAPIGatewayGetRequest, getSDSAPIGatewayPostRequest, getVlan, isResponseCode5xx,
    logOperationalMetric, thingNameToMac
} from "../../../util/Util";
import {
    ACTIVE,
    ALERT_ASSET_DEPLOY_MESSAGE,
    ALERT_ASSET_STATUS_MESSAGE, ALERT_ASSET_USE_CASE_CHANGE,
    ALERT_ASSET_USE_CASE_UPDATE, ALERT_RESTART_APPLICATION_FAILED,
    ALERT_UPDATE_ASSET_MESSAGE, ENDPOINT_CHANGE_THIN_CLIENT_USECASE, ENDPOINT_CREATE_REDEPLOYMENT,
    ENDPOINT_DELETE_THIN_CLIENT,
    ENDPOINT_DEPLOY_THIN_CLIENT,
    ENDPOINT_GET_CORE_DEVICE_STATUS, ENDPOINT_GET_SITE_DEVICES_CONNECTIVITY,
    ENDPOINT_GET_THIN_CLIENT_DEPLOYMENT_STATUS,
    ENDPOINT_SWITCH_OVER_THIN_CLIENT,
    LOADING_FAILED,
    LOADING_STRING, RESTART_APPLICATION_STATUS_TIMEOUT,
    SBL_ASSET_TYPE,
    SBLV2_ASSET_TYPE,
    SOFTWARE_STATUS_LOADER_TIMER, SW_STATUS,
    THIN_CLIENT_ASSET_TYPE,
    USECASE_STATUS_LOADER_TIMER
} from "../../../util/Constants";
import {getAssetByAssetLabel, getAssets, setAssetStatus, updateAsset} from "../../../resources/AssetResource";
import {getAPIGatewayDataFromParent} from "../../../handler/ParentDataHandler";
import sleep from "../../ledcontroller/bintester/util/sleep";
import HttpStatus from 'http-status-codes';

export const metricProcessName = "THIN_CLIENT_DEVICE_DETAILS";

export function fetchThinClientStatusDetails(dispatcher, model) {
    getThinClientDeviceStatusDetails(dispatcher, model)
}

export function setThinClientStatusDetailsToRestartedState(dispatcher, model, mac) {
    model.thinClientDeviceInformation[mac].swStatus = SW_STATUS.RESTARTED;
    model.thinClientDeviceInformation[mac].swType = SW_STATUS.DEPLOYED;

}

export function setThinClientStatusDetailsToRestartInProgressState(dispatcher, model, mac) {
    model.thinClientDeviceInformation[mac].swStatus = SW_STATUS.RESTART_IN_PROGRESS;
    model.thinClientDeviceInformation[mac].swType = SW_STATUS.RESTART_IN_PROGRESS;

}

export function fetchThinClientDeviceDetails(dispatcher) {
    const request = {
        nodeId: getNodeId(),
        assetType: THIN_CLIENT_ASSET_TYPE
    }
    getThinClientDeviceDetails(dispatcher, request)
}

export function setThinClientDeviceDetails(dispatcher, stateValues, mac) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        }
    }
    updateThinClientDeviceDetails(dispatcher, request, stateValues)
}

export async function deleteThinClientDeviceDetails(dispatcher, mac) {
    const request = {
        nodeId: getNodeId(),
        macAddress: mac
    };
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_DELETE_THIN_CLIENT);
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        dispatcher({type: 'LOAD_VIEW', data: {dispatcher}});
        logOperationalMetric(startTime, metricProcessName, "deleteThinClient", true, false);
    } else {
        const isFault = isResponseCode5xx(response.status)
        logOperationalMetric(startTime, metricProcessName, "deleteThinClient", false, isFault);
    }
}

export const extractThinClientDeviceList = (result) => {
    const model = {
        thinClientDeviceInformation: {},
        macAddressArray: [],
        gatewayNameList: []
    }
    if ("data" in result && "assetDetailsList" in result.data) {
        result.data.assetDetailsList.forEach((thinClientDeviceDetail) => {
            if (thinClientDeviceDetail.assetStatus === ACTIVE) {
                model.gatewayNameList.push(thinClientDeviceDetail.assetAttributes.gatewayName);
                model.macAddressArray.push(thinClientDeviceDetail.assetLabel.value);
                model.thinClientDeviceInformation[thinClientDeviceDetail.assetLabel.value] = {
                    mac: thinClientDeviceDetail.assetLabel.value,
                    ip: thinClientDeviceDetail.assetAttributes.ip,
                    connection: LOADING_STRING,
                    swStatus: LOADING_STRING,
                    swType: LOADING_STRING,
                    healthStatus: LOADING_STRING,
                    gatewayName: thinClientDeviceDetail.assetAttributes.gatewayName,
                    vlan: getVlan(thinClientDeviceDetail.assetAttributes.ip),
                    useCase: thinClientDeviceDetail.assetAttributes.useCase,
                    primary: thinClientDeviceDetail.assetAttributes.useCase === SBL_ASSET_TYPE
                             || thinClientDeviceDetail.assetAttributes.useCase === SBLV2_ASSET_TYPE ?
                        (!thinClientDeviceDetail.assetAttributes.primary ? "false" : thinClientDeviceDetail.assetAttributes.primary)
                        : "",
                    remark: !thinClientDeviceDetail.assetAttributes.remark ? "" : thinClientDeviceDetail.assetAttributes.remark,
                    startTime: !thinClientDeviceDetail.assetAttributes.monitoring ? "0" : JSON.parse(thinClientDeviceDetail.assetAttributes.monitoring).startTime,
                    endTime: !thinClientDeviceDetail.assetAttributes.monitoring ? "0" : JSON.parse(thinClientDeviceDetail.assetAttributes.monitoring).endTime,
                    reason: !thinClientDeviceDetail.assetAttributes.monitoring ? "" : JSON.parse(thinClientDeviceDetail.assetAttributes.monitoring).reason,
                }
            }
        });
    }
    return model;
}

export const getThinClientDeviceSoftwareStatusDetails = async (dispatcher, model) => {
    const request = {
        gatewayNameList: model.gatewayNameList
    }
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_THIN_CLIENT_DEPLOYMENT_STATUS);
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "getThinClientDeviceSoftwareStatusDetails", true, false);
        mergeSoftwareStatusToModel(response, model)
    } else {
        const isFault = isResponseCode5xx(response.status)
        logOperationalMetric(startTime, metricProcessName, "getThinClientDeviceSoftwareStatusDetails", false, isFault);
        model.macAddressArray.forEach((macAddress) => {
            model.thinClientDeviceInformation[macAddress].swStatus = LOADING_FAILED
            model.thinClientDeviceInformation[macAddress].swType = LOADING_FAILED
        })
    }
    dispatcher({type: "RECEIVE_DATA", data: model});
}

export const updateThinClientDeviceList = async (result, stateValues, dispatcher) => {
    const monitoring = {
        startTime: stateValues.startTime,
        endTime: stateValues.endTime,
        reason: stateValues.reason
    }
    result.assetDetails.assetAttributes.monitoring = JSON.stringify(monitoring);
    const responseSetAssetStatus = await setAssetStatus(result.assetDetails.assetLabel, ACTIVE);
    if (responseSetAssetStatus.status !== 200) {
        alert(ALERT_ASSET_STATUS_MESSAGE);
    } else if (responseSetAssetStatus.status === 200) {
        const getAssetResult = await getAssetByAssetLabel(result.assetDetails.assetLabel);
        const responseUpdateAsset = await updateAsset(result, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
        if (responseUpdateAsset.status !== 200) {
            alert(ALERT_UPDATE_ASSET_MESSAGE);
        }
    }
    fetchThinClientDeviceDetails(dispatcher)
}

export async function getThinClientDeviceStatusDetails(dispatcher, model) {
    const request = {
        nodeId: getNodeId(),
        deviceType: THIN_CLIENT_ASSET_TYPE
    }
    const startTime = Date.now();
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_SITE_DEVICES_CONNECTIVITY);
    const result = await getAPIGatewayDataFromParent(args)
    if (result.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "getThinClientDeviceStatusDetails", true, false);
        mergeStatusToModel(result, model)
    } else {
        const isFault = isResponseCode5xx(result.status)
        logOperationalMetric(startTime, metricProcessName, "getThinClientDeviceStatusDetails", false, isFault);
        setAllStatusToFailed(model)
    }
    await getThinClientDeviceSoftwareStatusDetails(dispatcher, model)
}

async function getThinClientDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    const result = await getAssets(request.nodeId, request.assetType)
    if (result.status === 200) {
        logOperationalMetric(startTime, metricProcessName, "getThinClientDeviceDetails", true, false);
        const thingClientDetails = extractThinClientDeviceList(result);
        await getThinClientDeviceStatusDetails(dispatcher, thingClientDetails)
        dispatcher({type: "RECEIVE_DATA", data: thingClientDetails});
    } else {
        const isFault = isResponseCode5xx(result.status)
        logOperationalMetric(startTime, metricProcessName, "getThinClientDeviceDetails", false, isFault);
        dispatcher({type: "RECEIVE_DATA", data: []});
    }
}

async function updateThinClientDeviceDetails(dispatcher, request, stateValues) {
    const startTime = Date.now();
    getAssetByAssetLabel(request.assetLabel).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "updateThinClientDeviceDetails", true, false);
            dispatcher({
                type: "RECEIVE_DATA",
                data: updateThinClientDeviceList(result.data.asset, stateValues, dispatcher)
            });
        } else {
            const isFault = isResponseCode5xx(result.status)
            logOperationalMetric(startTime, metricProcessName, "updateThinClientDeviceDetails", false, isFault);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

export async function postUpdatedRemarkToDevice(device, newRemark) {
    const getAssetResult = await getAssetByAssetLabel(getAssetLabelFromMac(device.mac));
    const newAsset = convertTableJsonToEdgeGatewayAsset({...getAssetResult.data.asset.assetDetails.assetAttributes, remark: newRemark}, THIN_CLIENT_ASSET_TYPE, ACTIVE, device);
    const responseUpdateAsset = await updateAsset(newAsset, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
    if (responseUpdateAsset.status !== 200) {
        alert(ALERT_UPDATE_ASSET_MESSAGE);
    }
}

function setAllStatusToFailed(model) {
    model.macAddressArray.forEach((macAddress) => {
        model.thinClientDeviceInformation[macAddress].connection = LOADING_FAILED
        model.thinClientDeviceInformation[macAddress].healthStatus = LOADING_FAILED
        model.thinClientDeviceInformation[macAddress].swStatus = LOADING_FAILED
    })
}

function mergeStatusToModel(response, model) {
    if ("data" in response && "deviceConnectivityList" in response.data) {
        response.data.deviceConnectivityList.forEach((singleThinClientDeviceStatusDetail) => {
            const mac = singleThinClientDeviceStatusDetail.identifier
            if (model.thinClientDeviceInformation[mac]) {
                model.thinClientDeviceInformation[mac].connection = singleThinClientDeviceStatusDetail.status ? singleThinClientDeviceStatusDetail.status : LOADING_FAILED
                //This will always fail as above API only provide internet connectivity
                model.thinClientDeviceInformation[mac].healthStatus = singleThinClientDeviceStatusDetail.deepHealthStatus ? singleThinClientDeviceStatusDetail.deepHealthStatus : LOADING_FAILED
                if(model.thinClientDeviceInformation[mac].swStatus === LOADING_STRING)
                    model.thinClientDeviceInformation[mac].swStatus = LOADING_FAILED
                if(model.thinClientDeviceInformation[mac].swType === LOADING_STRING)
                    model.thinClientDeviceInformation[mac].swType = LOADING_FAILED
            }
        })
    }
    model.macAddressArray.forEach((macAddress) => {
        if( model.thinClientDeviceInformation[macAddress].connection === LOADING_STRING) {
            model.thinClientDeviceInformation[macAddress].connection = LOADING_FAILED
        }
        if( model.thinClientDeviceInformation[macAddress].healthstatus === LOADING_STRING) {
            model.thinClientDeviceInformation[macAddress].healthstatus = LOADING_FAILED
        }
    })
}

function mergeSoftwareStatusToModel(response, model) {
    if ("data" in response && "thinClientDeploymentList" in response.data) {
        response.data.thinClientDeploymentList.forEach((singleThinClientDeviceSoftwareStatusDetail) => {
            // convert thingName tc-ababababab-DBE2_Core format to mac address ab:ab:ab:ab:ab
            const mac = thingNameToMac(singleThinClientDeviceSoftwareStatusDetail.thingName)
            if(model.thinClientDeviceInformation[mac]) {
                model.thinClientDeviceInformation[mac].swStatus = singleThinClientDeviceSoftwareStatusDetail.deploymentStatus ? singleThinClientDeviceSoftwareStatusDetail.deploymentStatus : LOADING_FAILED
                model.thinClientDeviceInformation[mac].swType = singleThinClientDeviceSoftwareStatusDetail.deploymentType ? singleThinClientDeviceSoftwareStatusDetail.deploymentType : LOADING_FAILED
            }
        })
    }
    model.macAddressArray.forEach((macAddress) => {
        if( model.thinClientDeviceInformation[macAddress].swStatus === LOADING_STRING) {
            model.thinClientDeviceInformation[macAddress].swStatus = LOADING_FAILED
        }
        if( model.thinClientDeviceInformation[macAddress].swType === LOADING_STRING) {
            model.thinClientDeviceInformation[macAddress].swType = LOADING_FAILED
        }
    })
}

export async function deployThinClient(dispatcher, mac, useCase) {
    try {
        const deploymentInput = {
            nodeId: getNodeId(),
            macAddress: mac,
            thinClientUsecase: useCase
        };
        dispatcher({type: 'UPDATE_STATUS_LOADER', data: {mac: mac, loadingField: 'softwareStatusLoader', loaderVisible: true}})
        const startTime = Date.now();
        const args = getAPIGatewayPostRequest(deploymentInput, ENDPOINT_DEPLOY_THIN_CLIENT);
        getAPIGatewayDataFromParent(args).then(response => {
            if (response.status === 200) {
                logOperationalMetric(startTime, metricProcessName, "deployThinClient", true, false);
                setTimeout(()=>{
                    dispatcher({type: 'LOAD_VIEW', data: {dispatcher: dispatcher}});
                    dispatcher({type: 'UPDATE_STATUS_LOADER', data: {mac: mac, loadingField: 'softwareStatusLoader', loaderVisible: false}})
                },SOFTWARE_STATUS_LOADER_TIMER)
            } else {
                const isFault = isResponseCode5xx(response.status)
                logOperationalMetric(startTime, metricProcessName, "deployThinClient", false, isFault);
                dispatcher({type: 'LOAD_VIEW', data: {dispatcher: dispatcher}});
                dispatcher({type: 'UPDATE_STATUS_LOADER', data: {mac: mac, loadingField: 'softwareStatusLoader', loaderVisible: false}})
            }
        });
    } catch (e) {
        console.log(`Mac Address ${mac} deployment API failed due to `, e);
        dispatcher({type: 'UPDATE_STATUS_LOADER', data: {mac: mac, loadingField: 'softwareStatusLoader', loaderVisible: false}})
        alert(ALERT_ASSET_DEPLOY_MESSAGE);
    }
}

async function checkAndUpdateData(startTime, args, coreDeviceStatusResponse) {
    const response = await getAPIGatewayDataFromParent(args);
    if (!(response.status === 200 && response.data.updatedAt !== coreDeviceStatusResponse.data.updatedAt)) {
        const currentTime = Date.now();
        if (currentTime - startTime < RESTART_APPLICATION_STATUS_TIMEOUT) {
            await sleep(5000);
            await checkAndUpdateData(startTime, args, coreDeviceStatusResponse);
        } else {
            alert(ALERT_RESTART_APPLICATION_FAILED);
        }
    }
}

export async function restartApplication(dispatcher, mac) {
    const coreDeviceName = convertMacToCoreDeviceName(mac);
    const request = {
        thingName : coreDeviceName
    }
    dispatcher({type: 'LOAD_VIEW_FOR_GREENGRASS_RESTART', data: {dispatcher: dispatcher, mac: mac}});
    try {

        const args = getSDSAPIGatewayGetRequest(request, ENDPOINT_GET_CORE_DEVICE_STATUS + coreDeviceName);
        const coreDeviceStatusResponse = await getAPIGatewayDataFromParent(args);

        const argsNew = getSDSAPIGatewayPostRequest(request, ENDPOINT_CREATE_REDEPLOYMENT);
        const startTime = Date.now();
        getAPIGatewayDataFromParent(argsNew).then(async response => {
            if (response.status === 200) {
                logOperationalMetric(startTime, metricProcessName, "deployThinClient", true);
                await sleep(30000);
                await checkAndUpdateData(startTime, args, coreDeviceStatusResponse);
                dispatcher({type: 'LOAD_VIEW_FOR_GREENGRASS_RESTART_COMPLETE', data: {dispatcher: dispatcher, mac: mac}});
                dispatcher({type: 'UPDATE_STATUS_LOADER', data: {mac: mac, loadingField: 'softwareStatusLoader', loaderVisible: false}})
                await sleep(15000);
                dispatcher({type: 'LOAD_VIEW', data: {dispatcher: dispatcher}});

            } else {
                logOperationalMetric(startTime, metricProcessName, "deployThinClient", false);
                alert(ALERT_RESTART_APPLICATION_FAILED);
                dispatcher({type: 'LOAD_VIEW', data: {dispatcher: dispatcher}});
                dispatcher({type: 'UPDATE_STATUS_LOADER', data: {mac: mac, loadingField: 'softwareStatusLoader', loaderVisible: false}})
            }
        });

    } catch(e) {
        console.log(`Mac Address ${mac} Redeployment API failed due to `, e);
        dispatcher({type: 'UPDATE_STATUS_LOADER', data: {mac: mac, loadingField: 'softwareStatusLoader', loaderVisible: false}})
        alert(ALERT_RESTART_APPLICATION_FAILED);
    }

}

export async function toggleThinClientUseCase(dispatcher, mac, useCase) {
    try {
        const requestInput = {
            nodeId: getNodeId(),
            macAddress: mac,
            thinClientUsecase: useCase
        };
        dispatcher({type: 'UPDATE_STATUS_LOADER', data: {mac: mac, loadingField: 'usecaseStatusLoader', loaderVisible: true}})
        const startTime = Date.now();
        const args = getAPIGatewayPostRequest(requestInput, ENDPOINT_SWITCH_OVER_THIN_CLIENT);
        const response = await getAPIGatewayDataFromParent(args);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "switchOverThinClient", true, false);
            setTimeout(()=>{
                dispatcher({type: 'LOAD_VIEW', data: {dispatcher: dispatcher}});
                dispatcher({type: 'UPDATE_STATUS_LOADER', data: {mac: mac, loadingField: 'usecaseStatusLoader', loaderVisible: false}})
            },USECASE_STATUS_LOADER_TIMER)
        } else {
            const isFault = isResponseCode5xx(response.status)
            logOperationalMetric(startTime, metricProcessName, "switchOverThinClient", false, isFault);
            dispatcher({type: 'LOAD_VIEW', data: {dispatcher: dispatcher}});
            dispatcher({type: 'UPDATE_STATUS_LOADER', data: {mac: mac, loadingField: 'usecaseStatusLoader', loaderVisible: false}})
        }
    } catch (e) {
        console.log(`Mac Address ${mac} toggle thin client use case API failed due to `, e);
        dispatcher({type: 'UPDATE_STATUS_LOADER', data: {mac: mac, loadingField: 'usecaseStatusLoader', loaderVisible: false}})
        alert(ALERT_ASSET_USE_CASE_UPDATE);
    }
}

export async function changeThinClientUseCase(dispatcher, mac, useCase, showCustomAlert) {
    try {
        const requestInput = {
            nodeId: getNodeId(),
            macAddress: mac,
            useCase: useCase
        };
        dispatcher({type: 'UPDATE_STATUS_LOADER', data: {mac: mac, loadingField: 'usecaseStatusLoader', loaderVisible: true}})
        const startTime = Date.now();
        const args = getAPIGatewayPostRequest(requestInput, ENDPOINT_CHANGE_THIN_CLIENT_USECASE);
        const response = await getAPIGatewayDataFromParent(args);
        if (response.status === HttpStatus.OK) {
            logOperationalMetric(startTime, metricProcessName, "changeThinClientUseCase", true, false);
            setTimeout(() => {
                dispatcher({type: 'LOAD_VIEW', data: {dispatcher: dispatcher}});
                dispatcher({
                    type: 'UPDATE_STATUS_LOADER',
                    data: {mac: mac, loadingField: 'usecaseStatusLoader', loaderVisible: false}
                })
            }, USECASE_STATUS_LOADER_TIMER)
        } else {
            const isFault = isResponseCode5xx(response.status)
            logOperationalMetric(startTime, metricProcessName, "changeThinClientUseCase", false, isFault);
            dispatcher({type: 'LOAD_VIEW', data: {dispatcher: dispatcher}});
            dispatcher({
                type: 'UPDATE_STATUS_LOADER',
                data: {mac: mac, loadingField: 'usecaseStatusLoader', loaderVisible: false}
            })
            showCustomAlert(ALERT_ASSET_USE_CASE_CHANGE);
        }
    } catch (e) {
        console.log(`Mac Address ${mac} change thin client use case API failed due to `, e);
        dispatcher({type: 'UPDATE_STATUS_LOADER', data: {mac: mac, loadingField: 'usecaseStatusLoader', loaderVisible: false}})
        showCustomAlert(ALERT_ASSET_USE_CASE_CHANGE);
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/thinclient/network/ThinClientOverviewNetworkAPI.js